/**
 * Riders Corner Header Component
 *
 * Single Responsibility: Displays the header section with badge, title, and subtitle
 * Open/Closed: Can be extended with additional props without modifying existing code
 */

import React from 'react';
import { Badge } from '@/design-system';
import { typographyColors, brandColors, spacing } from '@/design-system/utils';
import Image from 'next/image';

interface RidersCornerHeaderProps {
  className?: string;
}

export function RidersCornerHeader({
  className = '',
}: RidersCornerHeaderProps) {
  return (
    <div
      className={`flex flex-col items-center ${className}`}
      style={{
        gap: spacing[4], // 16px gap between header elements per Figma
      }}
    >
      <Badge variant='primary' size='md' className='px-3 py-1'>
        <div
          style={{ backgroundColor: brandColors.secondary }}
          className='border border-black/12 rounded-md p-1.5'
        >
          <Image
            src='/assets/images/icons/motorcycle.svg'
            alt='Motorcycle icon'
            width={16}
            height={16}
          />
        </div>
        <span className='font-bold' style={{ color: typographyColors.primary }}>
          Riders Corner
        </span>
      </Badge>

      <h1
        className='text-3xl md:text-5xl font-semibold text-center leading-tight md:leading-normal'
        style={{ color: typographyColors.primary }}
      >
        Trails, tips, and trips for bikers and explorers
      </h1>

      <p
        className='text-base md:text-xl font-normal text-center'
        style={{ color: typographyColors.primary }}
      >
        For the Road Enthusiasts
      </p>
    </div>
  );
}
